import b from 'b_';
import { SimpleCallback } from 'platform-components/common';
import React, { ReactNode } from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './calendar-plan-showcase__carousel-next-card-block.scss';

interface Props {
    children: ReactNode;
    onClick?: SimpleCallback;
}

export const CalendarPlanShowcaseCarouselNextCardBlock = ({ children, onClick }: Props) => (
    <div className={b('calendar-plan-showcase', 'carousel-next-card')} {...accessibleClick(onClick)}>
        {children}
    </div>
);
